/**
 * Balance refresh event - when fired, consumers (e.g. Header) should refetch balance.
 * Call dispatchBalanceRefresh() after any successful balance fetch so the header stays in sync.
 */
export const BALANCE_REFRESH_EVENT = 'app-balance-should-refresh';

export function dispatchBalanceRefresh(): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(BALANCE_REFRESH_EVENT));
  }
}
